/**
 * Breadcrumb trail (stock Oxygen `Breadcrumbs`/`Breadcrumb`). Links navigate via
 * the SPA router (preventDefault on the anchor) rather than a full page load.
 */

import Breadcrumbs, { Breadcrumb } from '@8x8/oxygen-breadcrumbs';
import { navigate } from '../router';

export interface Crumb {
    label: string;
    /** Target path; omit on the final (active) crumb. */
    to?: string;
}

export function Crumbs({ items }: { items: Crumb[] }): JSX.Element {
    return (
        <div style={{ marginBottom: 14 }}>
            <Breadcrumbs>
                {items.map((c, i) => {
                    const isLast = i === items.length - 1;

                    return (
                        <Breadcrumb
                            key={c.label}
                            isActive={isLast}
                            href={c.to ?? undefined}
                            onClick={(e: React.MouseEvent) => {
                                if (c.to) {
                                    e.preventDefault();
                                    navigate(c.to);
                                }
                            }}
                        >
                            {c.label}
                        </Breadcrumb>
                    );
                })}
            </Breadcrumbs>
        </div>
    );
}
